import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CsvExporterService } from './csv-exporter.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule],
})
export class CsvExporterModule {
  static forRoot(): ModuleWithProviders<CsvExporterModule> {
    return {
      ngModule: CsvExporterModule,
      providers: [CsvExporterService],
    };
  }
}
